import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom'; 
import curbsideAPIService from '../../services/curbsideAPIService';

interface ProtectedRouteProps {
  element: React.ReactNode;
  allowedRoles: string[]; 
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, allowedRoles }) => {
  const token = localStorage.getItem('userToken');
  const role = localStorage.getItem('role');
  const location = useLocation(); 

  useEffect(() => {
    if (token) {
      curbsideAPIService.checkToken(); 
    }
  }, [token]);

 
  if (!token || !role) {

    if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('userToken');
        localStorage.removeItem('selectedStoreIds');
        localStorage.removeItem('chainId');
        localStorage.removeItem('role');
    }
    
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // Check if user's role is in the allowedRoles array
  if (!allowedRoles.includes(role)) {
    // Redirect to a fallback route (e.g., dashboard or unauthorized page)
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }

  return <>{element}</>;
};

export default ProtectedRoute;